// src/App.tsx
import React, { ReactElement, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import axios from "axios";

import LoginPage from "./components/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import FileDetailPage from "./pages/FileDetailPage"; 
import SearchBundlePage from "./pages/SearchBundlePage"; 
import ViewerPage from "./pages/ViewerPage";

import { API_BASE } from "./services/api";
import type { ApiResponse } from "./types/api-response";

import "katex/dist/katex.min.css";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

// ✅ 공통 인증 헤더 유틸 (다른 곳과 패턴 맞춤)
const getAuthHeaders = () => ({
  "x-user-id": localStorage.getItem("user_id") || "",
  "x-access-token": localStorage.getItem("access_token") || "",
  "x-refresh-token": localStorage.getItem("refresh_token") || "",
});

function PrivateRoute({ children }: { children: ReactElement }) {
  const accessToken = localStorage.getItem("access_token");
  return accessToken ? children : <Navigate to="/login" replace />;
}

/**
 * 서버에 실제로 오너(티어0)인지 확인하는 가드
 *  - GET /api/admin/users 호출이 200 && success=true 이면 오너로 판단
 *  - 401/403/기타 에러면 대시보드로 리다이렉트
 */
function ServerOwnerGuard({ children }: { children: ReactElement }) {
  const [status, setStatus] = useState<"checking" | "allow" | "deny">(
    "checking"
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get<ApiResponse<any[]>>(
          `${API_BASE}admin/users`,
          {
            headers: getAuthHeaders(),
            params: { limit: 1 },
          }
        );
        if (res?.data?.success) {
          setStatus("allow");
        } else {
          setStatus("deny");
        }
      } catch {
        setStatus("deny");
      }
    })();
  }, []);

  if (status === "checking")
    return <div style={{ padding: 24 }}>권한 확인 중…</div>;
  if (status === "deny") return <Navigate to="/" replace />;

  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* 로그인 */}
        <Route path="/login" element={<LoginPage />} />

        {/* 대시보드 */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        {/* 파일 상세 페이지: vN, heading_json, content 프리뷰 확인용 */}
        <Route
          path="/files/:fileId"
          element={
            <PrivateRoute>
              <FileDetailPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/search-bundles"
          element={
            <PrivateRoute>
              <SearchBundlePage />
            </PrivateRoute>
          }
        />


        <Route path="/viewer" element={<ViewerPage />} />

        

        {/* 기타 → 대시보드 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
